import apiUrl from '../../../../utils/settings';

export const updateUserInfoUrl = () => {
  return apiUrl + '/users/update-user';
};
export const deleteUserUrl = () => {
  return apiUrl + '/users/make-user-inactive';
};
export const getUserFirmsUrl = () => {
  return apiUrl + '/company/firms';
};
export const deleteUserFirmsUrl = () => {
  return apiUrl + '/company/firms';
};
export const updateFirmInfoUrl = () => {
  return apiUrl + '/company/edit-company';
};
export const updateActiveStatusOfDealershipCoUrl = () => {
  return apiUrl + '/manufacturer-role-map/update-active';
};
export const getEmployeesUrl = () => {
  return apiUrl + '/users/employees';
};
export const SendOTPThroughExistingUserUrl = () => {
  return apiUrl + '/onboarding/send-otp-request-by-through-existing-user';
};
export const addUserThroughExistingCompanyUrl = () => {
  return apiUrl + '/onboarding/add-user-through-existing-company';
};
export const deleteEmployeeUrl = () => {
  return apiUrl + '/onboarding/delete-company-user';
};
export const SendOTPByPhoneUrl = () => {
  return apiUrl + '/auth/send-otp-request-by-user-phone';
};
export const SendOTPToChangePhoneNumberUrl = () => {
  return apiUrl + '/auth/send-otp-request-to-change-phone_number';
};
export const VerifyOTPToChangePhoneNumberUrl = () => {
  return apiUrl + '/auth/verify-otp-to-change-user-phone_number';
};
export const VerifyToChangePhoneNumberOfCompanyOrUserUrl = () => {
  return apiUrl + '/auth/edit-user-company-phone-number';
};
export const addRolePermissionUrl = () => {
  return apiUrl + '/secondary-permissions/assign-new-role-to-employee';
};
